import { SagaIterator } from 'redux-saga';
import { all } from 'redux-saga/effects';

import { ClientReducer } from '@bcp-nextgen-dx-touchpoint-framework/react-js';

import { baseReducer, BaseState } from './base';
import { NavigationState, navigationReducer } from './navigation';
import { servicesReducer, ServicesState } from './services';
import { TempDataState, tempDataReducer } from './tempData';
import { tokenDataReducer, tokenDataState } from './tokenData';
import { userInputReducer, UserInputState } from './userInput';

export interface AppState {
	baseState: BaseState;
	servicesState: ServicesState;
	userInputState: UserInputState;
	navigationState: NavigationState;
	tempDataState: TempDataState;
	tokenDataState: tokenDataState;
}

export const rootReducer: ClientReducer<AppState> = {
	baseState: {
		reducer: baseReducer,
	},
	servicesState: {
		reducer: servicesReducer,
	},
	userInputState: {
		reducer: userInputReducer,
	},
	navigationState: {
		reducer: navigationReducer,
	},
	tempDataState: {
		reducer: tempDataReducer,
	},
	tokenDataState: {
		reducer: tokenDataReducer,
	},
};

export function* rootSaga(): SagaIterator {
	yield all([]);
}
